import React, {Component} from 'react';
import {Dropdown, IDropdownOption} from "office-ui-fabric-react";

interface MegaMenuItemSelectorProps {
    onSelectionChanged: (option: MegaMenuOption) => void;
    megaMenuOptions: MegaMenuOptions;
    selectedMegamenuOption?: MegaMenuOption;
    disabled: boolean;
}

interface MegaMenuItemSelectorState {
}

export interface MegaMenuOptions {
    [key: string]: MegaMenuOption | null;

    one: MegaMenuOption | null;
    two: MegaMenuOption | null;
    three: MegaMenuOption | null;
    four: MegaMenuOption | null;
}

export interface MegaMenuOption {
    listName: string;
    sitePathForList: string;
}

export class MegaMenuItemSelector extends Component<MegaMenuItemSelectorProps,MegaMenuItemSelectorState> {
    static displayName = MegaMenuItemSelector.name;
    
    private static megaMenuOptionsToDropdownOptions(megaMenuOptions: MegaMenuOptions): IDropdownOption[]
    {
        return [megaMenuOptions.one,megaMenuOptions.two,megaMenuOptions.three,megaMenuOptions.four]
            .filter(mmo => mmo !== null)
            .filter(mmo => mmo?.listName.indexOf("My Subjects") !== 0)
            .filter(mmo => mmo?.listName.indexOf("My Resources") !== 0)
            .filter(mmo => mmo?.listName.indexOf("Classes 20") !== 0)
            .map(mmo => MegaMenuItemSelector.megamenuOptionToDropdownOption(mmo!));
    }
    
    public static megamenuOptionToDropdownOption(megamenuOption: MegaMenuOption) : IDropdownOption
    {
        return {
            key: `${megamenuOption.listName}`,
            text: megamenuOption.listName,
            data: megamenuOption
        };
    }
    
    public static findMegaMenuOptionByDropdownKey(megaMenuOptions: MegaMenuOptions,dropdownKey: string): MegaMenuOption | undefined
    {
        if(megaMenuOptions === undefined)
        {
            return undefined;
        }
        
        const definedOptions = [megaMenuOptions.one,megaMenuOptions.two,megaMenuOptions.three,megaMenuOptions.four].filter(mmo => mmo !== null) as MegaMenuOption[];
        
        return definedOptions.map((mmo: MegaMenuOption) => {
            return {
                megaMenuOption: mmo,
                dropdownOption: MegaMenuItemSelector.megamenuOptionToDropdownOption(mmo)
            };
        })
        .filter((x) => x.dropdownOption.key === dropdownKey)[0]?.megaMenuOption;
    }
    
    constructor(props: MegaMenuItemSelectorProps) {
        super(props);
        
        this.state = {
        }
    }

    async componentDidMount(): Promise<void> {

    }

    async componentDidUpdate(prevProps: Readonly<MegaMenuItemSelectorProps>, prevState: any): Promise<void> {
    }
    render(): JSX.Element 
    {
        const options: IDropdownOption[] = MegaMenuItemSelector.megaMenuOptionsToDropdownOptions(this.props.megaMenuOptions);
        const selectedKey = this.props.selectedMegamenuOption ? MegaMenuItemSelector.megamenuOptionToDropdownOption(this.props.selectedMegamenuOption)?.key : undefined;

        return (
                <Dropdown
                    label="Mega Menu"
                    disabled={this.props.disabled}
                    selectedKey={selectedKey}
                    onChange={(e,newOption) => {
                        this.props.onSelectionChanged(newOption!.data);
                    }}
                    placeholder={"Select an option"}
                    options={options}
                    styles={{ dropdown: { width: 300 } }}
                />
        );
    }
}